import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { UseInputFactoryReturnProps } from '../InputFactoryProps'
import {  setFieldValue, setIsFieldFirstFill } from 'store/FormSlice/FormSlice'
import { TFieldValues, TFieldsObjectNames } from 'models/Form/FieldsModels'
import useFormHandlers from 'components/Form/AppForm/hooks/useFormHandlers'


/**
 * Custom hook obsługujący logikę strony startowej aplikacji
*/
const useInputFactoryLogic = (): UseInputFactoryReturnProps => {

   const FIELD_ERROR_CLASS_NAME = 'form-input-base-error'
   
   const dispatch = useDispatch<AppDispatch>()
   const { handleValidateSingleField } = useFormHandlers()

   const handleSaveInputValueToState = React.useCallback(( fieldName: TFieldsObjectNames, newValue: string) => {
      dispatch(setFieldValue({ fieldName: fieldName, newValue: newValue }))
   }, [])

   const handleOnPasteDisabled = React.useCallback((e: React.ClipboardEvent<HTMLInputElement>, isPasteDisabled: boolean | undefined) => {
      if (isPasteDisabled === true) { //Jeśli flaga 'isPasteDisabled' jest ustawiona blokujemy możliwość wklejania tekstu do kontrolki
         e.preventDefault()
      }
   }, [])

   const handleSetIsFieldFirstFill = React.useCallback((fieldName: TFieldsObjectNames) => {
      dispatch(setIsFieldFirstFill(fieldName))
   }, [])

   
   //TODO POPRAWIĆ TYP  fieldValidationFunction
   const handleValidateField = React.useCallback((fieldName: TFieldsObjectNames, newValue: TFieldValues, fieldValidationFunction: any) => {
      if(fieldValidationFunction !== undefined){
         handleValidateSingleField(fieldName, newValue, fieldValidationFunction)
      }
   }, [])

   return {
      fieldErrorClassName: FIELD_ERROR_CLASS_NAME,
      handleValidateField,
      handleSaveInputValueToState,
      handleOnPasteDisabled,
      handleSetIsFieldFirstFill
   }

}

export default useInputFactoryLogic